// 负责 Mock 支付页展示，与支付 Provider 事件模拟和订单摘要关联。
import { AlertCircle, ArrowLeft, Check, CircleX, Clock } from "lucide-react";
import type { MockPaymentOutcome, Order } from "../../domain/orders";
import { OrderSummary } from "./OrderSummary";

type MockCheckoutViewProps = {
  isPaymentResolving: boolean;
  order: Order;
  paymentError: string;
  onBackToBag: () => void;
  onResolvePayment: (outcome: MockPaymentOutcome) => void;
};

export const MockCheckoutView = ({
  isPaymentResolving,
  order,
  paymentError,
  onBackToBag,
  onResolvePayment
}: MockCheckoutViewProps) => {
  return (
    <main className="flow-shell">
      <section className="checkout-workspace" aria-label="Mock checkout">
        <button className="text-button" type="button" onClick={onBackToBag}>
          <ArrowLeft aria-hidden="true" size={18} />
          Back to bag
        </button>

        <div className="checkout-grid">
          <section className="mock-payment-panel">
            <p>Mock provider</p>
            <h1>Simulate a payment result</h1>
            <span>
              This page is local-only and does not process money. It exercises
              order state transitions before a real payment provider is added.
            </span>

            <div className="mock-actions">
              <button
                className="primary-button"
                type="button"
                disabled={isPaymentResolving}
                onClick={() => onResolvePayment("success")}
              >
                <Check aria-hidden="true" size={19} />
                Pay successfully
              </button>
              <button
                className="secondary-button"
                type="button"
                disabled={isPaymentResolving}
                onClick={() => onResolvePayment("failure")}
              >
                <AlertCircle aria-hidden="true" size={19} />
                Fail payment
              </button>
              <button
                className="secondary-button"
                type="button"
                disabled={isPaymentResolving}
                onClick={() => onResolvePayment("cancel")}
              >
                <CircleX aria-hidden="true" size={19} />
                Cancel payment
              </button>
              <button
                className="secondary-button"
                type="button"
                disabled={isPaymentResolving}
                onClick={() => onResolvePayment("expire")}
              >
                <Clock aria-hidden="true" size={19} />
                Expire session
              </button>
            </div>
            {paymentError ? (
              <p className="setup-note error">{paymentError}</p>
            ) : null}
          </section>

          <OrderSummary order={order} />
        </div>
      </section>
    </main>
  );
};
